
const digest = 'dbc477400713bf678c479a7411816e902a87856e11670ebb402782bb84f2f28e';
const classes = {"item":"_item_lzq4j_1","label":"_label_lzq4j_10","value":"_value_lzq4j_15","removeButton":"_removeButton_lzq4j_30"};
const css = `._item_lzq4j_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  margin-bottom: 12px;
  font-size: 14px;
}

._label_lzq4j_10 {
  color: #9ea0a5;
  flex-shrink: 0;
}

._value_lzq4j_15 {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #000000;
  font: inherit;
  cursor: pointer;
  text-align: left;
}
._value_lzq4j_15:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  outline-offset: 1px;
}

._removeButton_lzq4j_30 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 0 8px;
  padding: 2px;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
}
._removeButton_lzq4j_30:hover {
  opacity: 0.85;
}
._removeButton_lzq4j_30:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.2);
  outline-offset: 1px;
}
._removeButton_lzq4j_30 img {
  width: 20px;
  height: 20px;
  display: block;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  